import { render, staticRenderFns } from "./CollaboardModal.vue?vue&type=template&id=2f3bf704&scoped=true"
import script from "./CollaboardModal.vue?vue&type=script&lang=js"
export * from "./CollaboardModal.vue?vue&type=script&lang=js"
import style0 from "./CollaboardModal.vue?vue&type=style&index=0&id=2f3bf704&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3bf704",
  null
  
)

export default component.exports